import {createFileRoute} from '@tanstack/react-router';

import PatientEventDetail from '@/patient/views/event/EventDetail';
import PractitionerEventDetail from '@/practitioner/views/event/EventDetail';
import {useIsPatient} from '@/shared/contexts/UserContext/useUserContext';

function EventDetailWrapper() {
  const isPatient = useIsPatient();
  return isPatient ? <PatientEventDetail /> : <PractitionerEventDetail />;
}

export const Route = createFileRoute('/(shared)/events/$eventId')({
  component: EventDetailWrapper,
  loader: ({params}) => ({
    eventId: params.eventId
  })
});
